// extracted by mini-css-extract-plugin
module.exports = {"content":"qualify-modal_content__iDZXi","fiveStarsImg":"qualify-modal_fiveStarsImg__eAee1"};